export default __webpack_public_path__ + "static/media/remote-team.237a4070.svg";